export const ToolTypes = {
    TITLE: 'title',
    ZOOM_AND_PAN: 'panzoom',
    SPACE_IMAGE: 'spaceImage',
    ALPHA_CHANNEL_INSERTS: 'alphaChannelInserts'
}
